import React from 'react';

// Small deterministic color palette
const COLORS = [
  '#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf'
];

function nameToInitials(name) {
  if (!name) return 'U';
  // If looks like email, use part before @
  const emailIndex = name.indexOf('@');
  let n = name;
  if (emailIndex > 0) n = name.substring(0, emailIndex);
  
  // Check if email format has dot separator (firstname.lastname)
  if (n.includes('.')) {
    const parts = n.split('.').filter(Boolean);
    if (parts.length >= 2) {
      return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase();
    }
    if (parts.length === 1) {
      return parts[0].substring(0, 2).toUpperCase();
    }
  }
  
  // Otherwise split by spaces
  const parts = n.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return 'U';
  if (parts.length === 1) {
    // For single word, take first 2 chars
    return parts[0].substring(0, 2).toUpperCase();
  }
  return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase();
}

function hashStringToNumber(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = (h << 5) - h + str.charCodeAt(i);
    h |= 0; // convert to 32-bit int
  }
  return Math.abs(h);
}

const InitialAvatar = ({ name = 'U', size = 32, className = '', style = {}, src, useStoredAvatar = true }) => {
  // allow optional image avatar via `src` prop or `localStorage.userAvatar`.
  // Pass useStoredAvatar={false} when rendering OTHER users (presence, history),
  // otherwise everyone would show up wearing the current user's photo.
  const storedAvatar = useStoredAvatar && typeof window !== 'undefined'
    ? localStorage.getItem('userAvatar')
    : null;
  const imageSrc = src || storedAvatar || null;
  const initials = nameToInitials(name);
  const color = COLORS[hashStringToNumber(name) % COLORS.length];
  const fontSize = Math.max(12, Math.round(size / 2.5));

  const baseStyle = {
    width: size,
    height: size,
    borderRadius: '50%',
    background: color,
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: fontSize,
    fontWeight: 600,
    ...style,
  };
  if (imageSrc) {
    return (
      <img
        src={imageSrc}
        alt={name}
        className={`user-avatar ${className}`}
        style={{ width: size, height: size, borderRadius: '50%', objectFit: 'cover', ...style }}
      />
    );
  }

  return (
    <div className={`user-avatar ${className}`} style={baseStyle} aria-hidden>
      {initials}
    </div>
  );
};

export default InitialAvatar;
